// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel {
    static getAttributeTypeMap() {
        return ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel.attributeTypeMap;
    }
}
ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel.discriminator = undefined;
ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    }
];
//# sourceMappingURL=scriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel.js.map